/** How close financial actuals came to plan, as a 0-100 score — `100` if actuals met or
 *  exceeded plan, otherwise the proportional `actuals/plan` ratio. */
export const getFinancialAchievementScore = (
  actuals: number | null,
  plan: number | null
): number | null => {
  const nonNullablePlan = plan ?? 0
  const nonNullableActual = actuals ?? 0

  if (nonNullablePlan <= 0) {
    return null
  }

  if (nonNullableActual <= 0) {
    return 0
  }

  if (nonNullableActual >= nonNullablePlan) {
    return 100
  }

  return Math.round((nonNullableActual / nonNullablePlan) * 100)
}
